import '../styles/App.scss'
import '../styles/Chat.scss'
import {
    setJobStatus,
    setPublishedJobParams,
    setJobId,
    addComment,
    setFutureDateFrom,
    setFutureDateTo,
    setBagsNumber,
    setItemsOutside,
    setItemsInside,
    setAmount,
    setMsaId,
    setElevatorUse,
    setAttachments,
    setAddress,
    setJobCategories,
    setSubCategories,
    selectJobCategory,
    setBids
} from '../actions/setJobDetails'
import * as React from 'react'
import ReactDOM from 'react-dom'
import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'
import { AppBarContainer } from './CustomAppBar'
import PageTitle from '../components/PageTitle'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { StickyContainer, Sticky } from 'react-sticky'
import { FlatButton } from 'material-ui'
import * as classnames from 'classnames'
import { connect } from 'react-redux'
import { StoreState } from '../reducers'
import { JobStatus } from '../types/enums'
import { MessageAttributes, ChatMessage } from '../types/ChatMessage'
import { MessageAuthor } from '../types/enums/MessageAuthor'
import { TwilioChatService } from '../services/twilio/chat'
import { ChatProviderMessageItem } from '../components/Chat/ChatProviderMessageItem'
import { ChatClientMessageItem } from '../components/Chat/ChatClientMessageItem'
import {
    ActionType as ChatActionType,
    Actions as ChatActions
} from '../actions/chat'
import { LoadingSpinner } from '../components/LoadingSpinner'
import { Api } from '../services/api/api'
import { DialogBox } from '../components/DialogBox'
import { RouterAction, routerActions } from 'react-router-redux'
import { ROUTES } from '../constants/routes'
import { JobCategories } from '../types/jobCategories'
import {
    Job,
    JobCategory,
    PublishedJobParams,
    AddressInfo,
    AttachmentParams,
    Bid
} from '../types'
import ConformationDialog from '../components/ConfirmationDialog'

interface Props {
    userIdentity: string
    isBiddingInProgress: boolean
    isJobInProgress: boolean
    messages?: ChatMessage[]
    isMessagesReceived: boolean
    jobId: string
    jobStatus: string
    selectedJobCategory: string
    jobCategories: any[]
    bids: Bid[]
    UpdateNewMessagesCounter: (count: number) => ChatActionType
    onSetJobStatus: (status: string) => void
    routePush: (location: string) => RouterAction

    onSetJobId: (jobId: string) => void
    onPublishedJobParams: (publishedJobParams: PublishedJobParams) => void
    onAddComment: (event: string) => string
    onSetFutureDateFrom: (futureDateFrom: number) => void
    onSetFutureDateTo: (futureDateTo: number) => void
    onNumberOfBags: (event: any) => any
    onSetItemsOutside: (areItemsOutside: boolean) => void
    onSetItemsInside: (areItemsInside: boolean) => void
    onSetAmount: (amount: number) => void
    onSetMsaId: (msaId: string) => void
    onSetElevatorUse: (isElevatorNeeded: boolean) => void
    onSetStairsNeeded: (areStairsNeeded: boolean) => void
    onSetAttachments: (files: AttachmentParams[] | null) => void
    setAddress: (address?: AddressInfo) => any
    onSelectJobCategory: (name: string, id: string) => void
    onSetJobCategories: (jobCategories: Array<any>) => void
    onSetSubCategories: (subCategories: Array<any>) => void
    onSetBids: (bids: Bid[]) => void
}

interface State {
    messageText: string
    messages: ChatMessage[]
    isInReplyMode: boolean
    replyToSid: string
    isDialogOpen: boolean
    jobIsCancelledByHauler: boolean
    isJobReposted: boolean
    isCanceledByOtherDevice: boolean
    checkJobStatusInterval?: any
    isConformationDialogOpen: boolean
}

export class Chat extends React.Component<Props, State> {
    private scrollRef: any = React.createRef()
    private textAreaRef = React.createRef<HTMLTextAreaElement>()
    constructor(props) {
        super(props)

        this.state = {
            messageText: '',
            messages: [],
            isInReplyMode: false,
            replyToSid: '',
            isDialogOpen: false,
            jobIsCancelledByHauler: false,
            isJobReposted: false,
            isCanceledByOtherDevice: false,
            isConformationDialogOpen: false
        }
    }

    scrollDown = () => {
        const element = ReactDOM.findDOMNode(this.scrollRef.current)
        if (element instanceof Element) {
            element.scrollTop = element.scrollHeight
        }
    }

    componentDidMount() {
        this.props.UpdateNewMessagesCounter(0)
        this.scrollDown()
        let timer = setInterval(this.checkJobStatus, 2000)
        this.setState({ checkJobStatusInterval: timer })
    }

    componentDidUpdate() {
        this.scrollDown()
    }

    async componentWillUnmount() {
        const channel = TwilioChatService.getInstance().Channel
        await channel.setAllMessagesConsumed()
        const member = await channel.getMemberByIdentity(
            this.props.userIdentity
        )
        const attributes = {
            ...member.attributes,
            lastReadMessageIndex: member.lastConsumedMessageIndex
        }
        await member.updateAttributes(attributes)

        if (this.state.checkJobStatusInterval) {
            clearInterval(this.state.checkJobStatusInterval)
        }
    }

    checkJobStatus = () => {
        Api.getJob(this.props.jobId)
            .then((job: any) => {
                return job
            })
            .then(job => {
                let status: string = job.status
                if (
                    status === JobStatus.CANCELLED_BY_HAULER ||
                    status === JobStatus.DECLINED_AUTO ||
                    status === JobStatus.DECLINED_BY_HAULER
                ) {
                    Api.getActiveJobs().then((result: Array<any>) => {
                        if (result && result.length > 0) {
                            this.setState({
                                isJobReposted: true,
                                isDialogOpen: true,
                                jobIsCancelledByHauler: true
                            })
                            this.setJobDetails(result[0])
                        } else {
                            this.setState({
                                isDialogOpen: true,
                                jobIsCancelledByHauler: true
                            })
                        }
                    })
                } else if (
                    status === JobStatus.ACCEPTED &&
                    this.props.jobStatus == JobStatus.UNDER_REVIEW
                ) {
                    this.props.routePush(ROUTES.VIEW_BIDS)
                }
                this.props.onSetJobStatus(status)
            })
            .then(() => {
                this.checkBids()
            })
    }

    checkBids = () => {
        let countable = this.props.jobCategories[this.props.selectedJobCategory]
            .countable
        if (!countable && this.props.jobStatus == JobStatus.BIDDING_ACTIVE) {
            Api.getBidsForJob(this.props.jobId).then(bids => {
                if (bids.length == 0 && this.props.bids.length !== 0) {
                    this.setState({ isConformationDialogOpen: true })
                }
                this.props.onSetBids(bids)
            })
        }
    }

    setJobDetails = (job: Job) => {
        let status = job.status
        let hours = Math.floor(job.timeKeeping / 3600000)
        let minutes = Math.floor((job.timeKeeping - hours * 3600000) / 60000)
        let seconds = Math.floor(
            (job.timeKeeping - minutes * 60000 - hours * 3600000) / 1000
        )

        let publishedJobParams = {
            confirmed: true,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            createDate: job.createDate,
            timeKeeping: job.timeKeeping,
            timeStopBidding: job.timeStopBidding,
            secondTimeKeeping: 0,
            biddingActiveDate: 0
        }

        this.props.onSetJobId(job.id)
        this.props.onPublishedJobParams(publishedJobParams)
        this.props.onSetJobStatus(job.status)

        this.props.onAddComment(job.note ? job.note : '')
        this.props.onSetFutureDateFrom(job.futureDateFrom)
        this.props.onSetFutureDateTo(job.futureDateTo)
        this.props.onNumberOfBags(job.jobItems ? job.jobItems : null)
        this.props.onSetItemsOutside(
            job.areItemsOutside ? job.areItemsOutside : false
        )
        this.props.onSetItemsInside(
            job.areItemsInside ? job.areItemsInside : false
        )
        this.props.onSetAmount(job.amount ? job.amount : 0)
        this.props.onSetMsaId(job.msaId ? job.msaId : '')
        this.props.onSetElevatorUse(
            job.isElevatorNeeded ? job.isElevatorNeeded : false
        )
        this.props.onSetStairsNeeded(
            job.areStairsNeeded ? job.areStairsNeeded : false
        )
        this.props.onSetAttachments(job.attachments ? job.attachments : null)
        this.props.setAddress(job.address)

        Api.getCategoriesByZipCode(job.address.zipCode).then(
            (jobCategories: JobCategories[]) => {
                let selectedJobCategory = jobCategories.find(
                    (jobCategory: JobCategory) =>
                        jobCategory.id === job.jobCategoryId
                )
                let index = jobCategories.findIndex(
                    (jobCategory: JobCategory) =>
                        jobCategory.id === job.jobCategoryId
                )

                let jobCategoryName =
                    selectedJobCategory && selectedJobCategory.name
                        ? selectedJobCategory.name
                        : ''
                this.props.onSelectJobCategory(jobCategoryName, `${index}`)
                this.props.onSetJobCategories(jobCategories)
                this.props.onSetSubCategories(
                    jobCategories[index].subcategories
                )
            }
        )
    }

    jobCanceledByHauler = () => {
        this.handleDialogClose()
        if (this.state.checkJobStatusInterval) {
            clearInterval(this.state.checkJobStatusInterval)
        }
        this.state.isJobReposted
            ? this.props.routePush(ROUTES.VIEW_BIDS)
            : this.props.routePush(ROUTES.PICKUP_LOCATION)
    }

    onClientMessageChange = event => {
        this.setState({ messageText: event.target.value })
    }

    onReplyClick = (replyToSid: string) => {
        this.setState(
            {
                replyToSid: !this.state.isInReplyMode ? replyToSid : '',
                isInReplyMode: !this.state.isInReplyMode
            },
            () => {
                if (this.state.isInReplyMode) {
                    let textAreaRefCurrent = this.textAreaRef.current
                    if (textAreaRefCurrent !== null) {
                        textAreaRefCurrent.focus()
                    }
                }
            }
        )
    }

    sendMessage = () => {
        let attributes: MessageAttributes = {
            authorType: MessageAuthor.CLIENT,
            // respondTo: (this.props.isBiddingInProgress ? this.state.replyToSid : ''),
            respondTo: '',
            authorAvatar: ''
        }

        TwilioChatService.getInstance().sendMessage(
            this.state.messageText,
            attributes
        )
        this.setState({
            messageText: '',
            isInReplyMode: !this.state.isInReplyMode
        })
    }

    onTextAreaKeyDown = event => {
        if (event.key === 'Enter' && this.state.messageText.length !== 0) {
            this.sendMessage()
            event.preventDefault()
        }
    }

    handleDialogClose = () => {
        this.setState({
            isDialogOpen: false
        })
    }

    onConformationDialogOkClick = () => {
        this.setState({ isConformationDialogOpen: false })
        this.props.routePush(ROUTES.VIEW_BIDS)
    }
    componentWillReceiveProps(nextProps: Props) {
        if (nextProps.messages && nextProps.messages.length != 0) {
            this.setState({ messages: nextProps.messages })
            this.props.UpdateNewMessagesCounter(0)
        }
    }

    render() {
        let messages: ChatMessage[] = this.state.messages
        // if(!this.props.isBiddingInProgress)
        // {
        //     messages = this.state.messages
        // } else {
        //
        //     let providerMesssages = this.state.messages.filter(msg => {
        //         return msg.attributes.authorType === MessageAuthor.PROVIDER
        //     })
        //     let clientMessages = this.state.messages.filter(msg => {
        //         return msg.attributes.authorType === MessageAuthor.CLIENT
        //     })
        //     providerMesssages.map(providerMsg => {
        //         messages.push(providerMsg)
        //         clientMessages.map(clientMsg => {
        //             if (providerMsg.sid === clientMsg.attributes.respondTo) {
        //                 messages.push(clientMsg)
        //             }
        //
        //         })
        //     })
        // }
        let respondTo =
            this.state.messages &&
            this.state.messages
                .filter(msg => {
                    return (
                        msg.attributes.authorType === MessageAuthor.CLIENT &&
                        msg.attributes.respondTo &&
                        msg.attributes.respondTo !== ''
                    )
                })
                .map(val => val.attributes.respondTo)
        return (
            <BaseContainer pageName={EventType.CHAT}>
                <LoadingSpinner show={!this.props.isMessagesReceived} />
                <DialogBox
                    isDialogOpen={this.state.isDialogOpen}
                    handleDialogClose={this.handleDialogClose}
                    status={this.props.jobStatus}
                    jobCanceledByHauler={this.jobCanceledByHauler}
                    isCanceledByHauler={this.state.jobIsCancelledByHauler}
                    isJobReposted={this.state.isJobReposted}
                    isCanceledByOtherDevice={this.state.isCanceledByOtherDevice}
                />
                <ConformationDialog
                    title={StringResources.getString(
                        Strings.Chat.ConformationDialog.Titles.noBidsLeft
                    )}
                    content={StringResources.getString(
                        Strings.Chat.ConformationDialog.Messages.noBidsLeft
                    )}
                    isDialogOpen={this.state.isConformationDialogOpen}
                    OkButtonText={StringResources.getString(
                        Strings.Chat.ConformationDialog.Buttons.Ok.label
                    )}
                    onOkButtonClick={this.onConformationDialogOkClick}
                    disableBackDropClick={true}
                    disableEscapeKeyDown={true}
                />

                <AppBarContainer
                    isIconButtonsShown={true}
                    isMenuShown={false}
                    isChatIconShown={false}
                />
                <PageTitle
                    text={StringResources.getString(Strings.Chat.Title)}
                />
                <PerfectScrollbar
                    className="vertical-scrollbar"
                    ref={this.scrollRef}
                >
                    <div className="conversation-container">
                        {messages &&
                            messages.map(message => {
                                let messageAttributes = message.attributes as MessageAttributes
                                if (
                                    messageAttributes &&
                                    messageAttributes.authorType ===
                                        MessageAuthor.CLIENT
                                ) {
                                    return (
                                        <ChatClientMessageItem
                                            key={message.sid}
                                            message={message}
                                        />
                                    )
                                }
                                if (
                                    messageAttributes &&
                                    messageAttributes.authorType ==
                                        MessageAuthor.PROVIDER
                                ) {
                                    // if(!this.props.isBiddingInProgress)
                                    // {
                                    return (
                                        <ChatProviderMessageItem
                                            key={message.sid}
                                            onReplyClick={this.onReplyClick}
                                            message={message}
                                            isGroupChat={false}
                                            isInReplyMode={
                                                this.state.isInReplyMode
                                            }
                                            messageText={this.state.messageText}
                                        />
                                    )
                                    // } else {
                                    //     return (
                                    //         <ChatProviderMessageItem
                                    //         key={message.sid}
                                    //         onReplyClick={this.onReplyClick}
                                    //         message ={message}
                                    //         isGroupChat={this.props.isBiddingInProgress}
                                    //         isInReplyMode={this.state.isInReplyMode}
                                    //         messageText = {this.state.messageText}
                                    //         isQuestionAsnwered={(respondTo.indexOf(message.sid) != -1)}
                                    //         />
                                    //     )
                                    // }
                                }
                            })}
                    </div>
                </PerfectScrollbar>
                {
                    // this.props.isBiddingInProgress && !this.state.isInReplyMode ?
                    // null
                    // :
                    <StickyContainer className="sticky-footer chat-footer">
                        <Sticky>
                            {() => (
                                <div className="bottom-part bottom-part-chat hover">
                                    <textarea
                                        value={this.state.messageText}
                                        onChange={this.onClientMessageChange}
                                        onKeyDown={this.onTextAreaKeyDown}
                                        ref={this.textAreaRef}
                                    />
                                    <FlatButton
                                        label="Send"
                                        className={classnames(
                                            'flatbutton',
                                            'send-button',
                                            {
                                                disabled: !this.state
                                                    .messageText
                                            }
                                        )}
                                        disabled={!this.state.messageText}
                                        onClick={this.sendMessage}
                                    />
                                </div>
                            )}
                        </Sticky>
                    </StickyContainer>
                }
            </BaseContainer>
        )
    }
}
function mapStateToProps(state: StoreState) {
    return {
        userIdentity: state.auth.user && state.auth.user.email,
        isBiddingInProgress:
            state.jobDetails.status == JobStatus.BIDDING_ACTIVE ||
            state.jobDetails.status == JobStatus.CREATED ||
            state.jobDetails.status == JobStatus.UNDER_REVIEW,
        isJobInProgress:
            state.jobDetails.status == JobStatus.ACCEPTED ||
            state.jobDetails.status == JobStatus.HAULER_ARRIVING ||
            state.jobDetails.status == JobStatus.CONFIRM_ARRIVAL,
        messages: state.chat.messages,
        isMessagesReceived: state.chat.isMessagesReceived,
        jobId: state.jobDetails.jobId,
        jobStatus: state.jobDetails.status,
        selectedJobCategory: state.jobDetails.selectedJobCategory,
        jobCategories: state.jobDetails.jobCategories,
        bids: state.jobDetails.bids
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        routePush: (location: string) => dispatch(routerActions.push(location)),
        onSetJobStatus: (status: string) => dispatch(setJobStatus(status)),
        UpdateNewMessagesCounter: (count: number) =>
            dispatch(ChatActions.updateNewMessagesCounter(count)),
        onPublishedJobParams: (publishedJobParams: PublishedJobParams) =>
            dispatch(setPublishedJobParams(publishedJobParams)),
        onSetJobId: (jobId: string) => dispatch(setJobId(jobId)),
        onAddComment: (note: string) => dispatch(addComment(note)),
        onSetFutureDateFrom: (futureDateFrom: number) =>
            dispatch(setFutureDateFrom(futureDateFrom)),
        onSetFutureDateTo: (futureDateTo: number) =>
            dispatch(setFutureDateTo(futureDateTo)),
        onNumberOfBags: (jobItem: [{ subCategoryId: string; count: number }]) =>
            dispatch(setBagsNumber(jobItem)),
        onSetItemsOutside: (areItemsOutside: boolean) =>
            dispatch(setItemsOutside(areItemsOutside)),
        onSetItemsInside: (areItemsInside: boolean) =>
            dispatch(setItemsInside(areItemsInside)),
        onSetAmount: (amount: number) => dispatch(setAmount(amount)),
        onSetMsaId: (msaId: string) => dispatch(setMsaId(msaId)),
        onSetElevatorUse: (isElevatorNeeded: boolean) =>
            dispatch(setElevatorUse(isElevatorNeeded)),
        onSetAttachments: (files: Array<any>) =>
            dispatch(setAttachments(files)),
        setAddress: (address?: AddressInfo) => dispatch(setAddress(address)),
        onSetJobCategories: (jobCategories: Array<any>) =>
            dispatch(setJobCategories(jobCategories)),
        onSetSubCategories: (subCategories: Array<any>) =>
            dispatch(setSubCategories(subCategories)),
        onSelectJobCategory: (name: string, id: string) =>
            dispatch(selectJobCategory(name, id)),
        onSetBids: (bids: Bid[]) => dispatch(setBids(bids))
    }
}

export const ChatContainer = connect(mapStateToProps, mapDispatchToProps)(Chat)



// WEBPACK FOOTER //
// ./src/containers/Chat.tsx